import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import isNumber from 'lodash/isNumber';
import React from 'react';
import { dsColors } from 'src/shared/ds/variables';
import { pxToRem } from 'src/shared/helpers/pxToRem';

interface SkeletonPlaceholderProps {
    /**
     * Width: can be either a number or a percentage string e.g. "50%"
     */
    width: number | string;
    /**
     * Height: can be either a number or a percentage string e.g. "50%"
     */
    height: number | string;
    borderRadius?: number;
    marginTop?: number;
    marginRight?: number;
    marginBottom?: number;
}

export const SkeletonPlaceholder: React.FC<SkeletonPlaceholderProps> = ({
    width,
    height,
    borderRadius = 4,
    marginTop = 0,
    marginRight = 0,
    marginBottom = 0,
}) => {
    const backgroundColor = dsColors.neutral800;
    const highlightColor = '#F2F8FC';

    return (
        <SkeletonContainer
            backgroundColor={backgroundColor}
            highlightColor={highlightColor}
            css={{
                backgroundColor,
                overflow: 'hidden',
                width: isNumber(width) ? pxToRem(width) : width,
                height: isNumber(height) ? pxToRem(height) : height,
                borderRadius: pxToRem(borderRadius),
                marginTop: pxToRem(marginTop),
                marginRight: pxToRem(marginRight),
                marginBottom: pxToRem(marginBottom),
            }}
        />
    );
};

const skeletonKeyframes = keyframes`
  100% {
      transform: translateX(100%);
  }
`;

const SkeletonContainer = styled.div<{ backgroundColor: string; highlightColor: string }>(
    ({ backgroundColor, highlightColor }) => ({
        display: 'inline-block',
        position: 'relative',
        overflow: 'hidden',

        '&::after': {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            transform: 'translateX(-100%)',
            backgroundImage: `linear-gradient(90deg, ${backgroundColor}, ${highlightColor}, ${highlightColor}, ${backgroundColor})`,
            animation: `${skeletonKeyframes} 1.5s infinite`,
            content: '""',
        },
    }),
);
